import { SearchIncrementType } from './searchIncrementType';

export class SearchIncrement {
    type: SearchIncrementType = SearchIncrementType.Value;
    value = 0;
}
